import { Injectable, NgZone } from '@angular/core';

import { SuburbDataService } from '../../../../services/suburb-data.service';
import { detailView } from '../panel/suburb-facts';
import { apiErrorText } from './api-errors';
import { inZone } from './in-zone';
import { WorkspaceStateService } from './workspace-state.service';

/**
 * The selected suburb's detail for its panel (#256): ABS facts, the crawl's findings, its notes count, page gate and
 * change log (GET /website/suburbs/:salCode). Only the latest request's answer is kept, so a quick click through
 * several suburbs shows the last one.
 */
@Injectable()
export class SuburbDetailService {
  /** The server's detail plus the panel's counts (suburb-facts.ts detailView), or { error } when it failed. */
  detail: any = null;
  loading = false;

  private request = 0;

  constructor(
    private data: SuburbDataService,
    private zone: NgZone,
    private state: WorkspaceStateService
  ) {}

  load(code: string): void {
    const id = ++this.request;
    this.loading = true;
    this.data.detail(code).subscribe({
      next: inZone(this.zone, (d: any) => {
        if (id !== this.request) return;
        this.detail = detailView(d);
        this.loading = false;
        this.state.redraw();
      }),
      error: inZone(this.zone, (e: unknown) => {
        if (id !== this.request) return;
        this.loading = false;
        this.detail = { error: apiErrorText(e, 'could not load this suburb', ['message']) };
        this.state.redraw();
      }),
    });
  }

  clear(): void {
    this.detail = null;
  }

  /** The suburb's ABS name, once its detail has loaded ('' before). */
  get name(): string {
    return this.detail?.suburb?.name || '';
  }
}
